import React, { useEffect, useState } from 'react';
import { PlanoVinculadoEntidade } from '@entidades';
import { FichaContribPrevidencialService } from '@services';
import { Alert, StaticField } from '@intech/web-ui';
import { LoadingComponent } from '@components';
import { AxiosError } from "axios";

interface IProps {
  plano: PlanoVinculadoEntidade;
}

export const Quotas: React.FC<IProps> = ({ plano }) => {
  const [Quotas, setQuotas] = useState<any[]>([]);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const quotas = await FichaContribPrevidencialService.BuscarQuotas(plano.SQ_PLANO_PREVIDENCIAL);
        setQuotas(quotas);
      } catch (e) {
        const err = e as AxiosError;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [plano]);

  return (
    <>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && !Quotas && <Alert type={"info"}>{"Nehuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && Quotas &&
        <>
          <table className={"table table-striped table-sm"}>
            <thead>
              <tr>
                <th></th>
                <th className={"text-right"}>{"Valor Cota"}</th>
              </tr>
            </thead>
            <tbody>
              {Quotas && Quotas.map((quota: any, index: number) => {
                // Define o tipo de linha (td ou th) baseado no index. Se for o ultimo, será o total, e será th
                var Td = (props: any) => <td className={props.className}>{props.children}</td>;

                if (index === Quotas.length - 1)
                  Td = (props: any) => <th className={props.className}>{props.children}</th>;

                return (
                  <tr key={index}>
                    <Td>{quota.Key}</Td>
                    <Td className={"text-right"}>
                      <StaticField value={quota.Value} type={"money"} />
                    </Td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </>}
    </>
  );
}
